$(function () {
    if ($('#weekly-resource-container').length > 0) {
        initialiseDragAndDrop();
    }
});

var resourceContainer   = null;
var initialisedElements = [];
var isCurriculumSort    = false;

/**
 * Check if the user's device is a touchscreen
 */
function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

/**
 * Initialise drag and drop functionality for sortable sections and resources.
 */
export function initialiseDragAndDrop() {
    if (isTouchDevice() === false && isEditMode === true && (typeof filterByResourceType === 'undefined' || filterByResourceType === false)) {
        if ($('#weekly-resource-container').length > 0) {
            resourceContainer = $('#weekly-resource-container');
        } else if ($('#curriculum-resource-container').length > 0) {
            resourceContainer = $('#curriculum-resource-container');
            isCurriculumSort = true;
        }

        if ($('.sortable-section').length >= 2 && ($('#weekly-resource-container').length > 0 || filterBySubsection === false)) {
            initialiseSortableSections();
        }

        if ($('.sortable-subsection').length > 0) {
            initialiseSortableSubsections();
        }

        if ($('.sortable-resource').length >= 2 || $('.sortable-section').length >= 2 || $('.sortable-subsection').length >= 2) {
            initialiseSortableResources();
        }
    }
}

/**
 * Initialise sortable functionality for sections.
 */
function initialiseSortableSections() {
    addSectionHandles();

    var movedSectionId;

    const containerHeight = resourceContainer.height();
    resourceContainer.css('min-height', containerHeight + 'px');

    initialisedElements.push('#' + resourceContainer.attr('id'));

    resourceContainer.sortable({
        containment: 'parent',
        items: '.sortable-section:not(.unsortable)',
        axis: 'y',
        tolerance: 'intersect',
        scroll: true,
        opacity: 0.75,
        handle: '.drag-handle',
        forcePlaceholderSize: true,
        placeholder: {
            element: function (selectedSection) {
                movedSectionId = selectedSection.attr('data-section-id');
                return clonePlaceholder(selectedSection);
            },
            update: function () {
                return;
            },
        },
        update: function () {
            $(this).children().each(function (index) {
                $(this).attr('data-section-position', index + 1);
            });
            updatePositions($(this), 'section', movedSectionId);
        },
    });
}

function recalculateHeights() {
    $('.sortable-section, .sortable-subsection').each(function () {
        $(this).css('min-height', '');
        let containerHeight = $(this).height();
        $(this).css('min-height', containerHeight + 'px');
    });
}

/**
 * Initialise sortable functionality for subsections
 */
function initialiseSortableSubsections() {
    addSubsectionHandles();
    recalculateHeights();

    var movedSubsectionId;
    var parentSectionId;

    initialisedElements.push('.sortable-section');

    $('.sortable-section').sortable({
        containment: 'parent',
        items: '.sortable-subsection',
        axis: 'y',
        tolerance: 'intersect',
        scroll: true,
        opacity: 0.75,
        handle: '.drag-handle',
        forcePlaceholderSize: true,
        placeholder: {
            element: function (selectedSubsection) {
                movedSubsectionId = selectedSubsection.attr('data-section-id');
                return clonePlaceholder(selectedSubsection);
            },
            update: function () {
                return;
            },
        },
        start: function (event, ui) {
            parentSectionId = ui.item.parent();
        },
        update: function () {
            $(this).children('div').not(':first, .alert').each(function (index) {
                $(this).attr('data-section-position', index + 1);
            });
            updatePositions($(this), 'subsection', movedSubsectionId, parentSectionId);
        },
    });
}

/**
 * Initialise sortable functionality for resources.
 */
function initialiseSortableResources() {
    addResourceHandles();

    var placeholderUpdateCount = 0;
    var firstResourceList = null;
    var originalItemPosition;
    var movedResourceId;
    var moveFrom = null;
    var moveTo = null;

    initialisedElements.push('.sortable-resources');

    $('.sortable-resources').sortable({
        containment: resourceContainer,
        connectWith: '.sortable-resources',
        scroll: true,
        opacity: 0.75,
        axis: 'y',
        handle: '.drag-handle',
        dropOnEmpty: true,
        placeholder: {
            element: function (selectedResourceListItem) {
                movedResourceId = selectedResourceListItem.attr('data-pagesectionresourceyear-id') || selectedResourceListItem.attr('data-resource-id');
                return clonePlaceholder(selectedResourceListItem);
            },
            update: function (resourceListObject) {
                $('.no-resource-message').show();
                let resourceList = resourceListObject.element;
                resourceList.find('.no-resource-message').hide();
                if (placeholderUpdateCount === 0 && resourceList.find('.sortable-resource').length === 1) {
                    firstResourceList = resourceList;
                }

                if (placeholderUpdateCount === 1 && firstResourceList !== null) {
                    firstResourceList.append($('<p class="no-resource-message">No resources available</p>'));
                }

                placeholderUpdateCount++;
                recalculateHeights();
                return;
            },
        },
        start: function (event, ui) {
            moveFrom             = ui.item.parent();
            originalItemPosition = moveFrom.position();
        },
        stop: function (event, ui) {
            let releasedPosition = ui.item.position();
            if (releasedPosition.top === originalItemPosition.top && releasedPosition.left === originalItemPosition.left) {
                placeholderUpdateCount = 0;
                firstResourceList = null;
            }
        },
        remove: function () {
            moveFrom = $(this);
        },
        receive: function () {
            moveTo = $(this);
        },
        update: function () {
            $(this).children().each(function (index) {
                let sectionId = $(this).parent().parent().attr('data-section-id');
                $(this).attr('data-resource-position', index + 1).attr('data-section-id', sectionId);
            });

            let parent = $(this).parent();
            if (parent.hasClass('sortable-subsection')) {
                parent.find('.no-resource-message').remove();
            } else if (parent.hasClass('sortable-section')) {
                let sectionResources = parent.find('.sortable-resources').first();
                sectionResources.find('.no-resource-message').remove();
            }

            updatePositions($(this), 'resource', movedResourceId, moveFrom, moveTo);

            // Reset tracking variables
            moveFrom               = null;
            moveTo                 = null;
            placeholderUpdateCount = 0;
            firstResourceList      = null;
        },
    });
}

/**
 * Function to make the placeholder look like a clone of the selected item.
 */
function clonePlaceholder(selectedElement) {
    let tagType = selectedElement.prop('tagName').toLowerCase();
    let clonePlaceholder = $('<' + tagType + ' class="selected weekly-resources">' + selectedElement[0].innerHTML + '</' + tagType + '>');
    clonePlaceholder.css('opacity', '0.3');

    // Get computed padding and margins so subsections stay indented
    let computedStyles = window.getComputedStyle(selectedElement[0]);
    let padding = computedStyles.getPropertyValue('padding');
    let margin = computedStyles.getPropertyValue('margin');

    // Apply padding and margin to the cloned element
    clonePlaceholder.css({
        padding: padding,
        margin: margin,
    });

    return clonePlaceholder;
}

/**
 * Add handles to sections for sorting.
 */
function addSectionHandles() {
    $('.sortable-section:not(.unsortable) h3.section-title').each(function () {
        if ($(this).parent().find('.drag-handle').length === 0) {
            $(this).css('margin-left', '10px').parent().prepend(
                $('<div class="d-flex align-items-center" style="clear: both;"></div>').append(createHandleIconElement(), $(this))
            );
        }
    });
}

/**
 * Add handles to subsections for sorting.
 */
function addSubsectionHandles() {
    $('.sortable-section').each(function () {
        var subsections = $(this).find('.sortable-subsection');
        if (subsections.length > 1) {
            subsections.each(function () {
                var header = $(this).find('h4');
                if (header.find('.drag-handle').length === 0) {
                    header.css('margin-left', '10px').parent().prepend(
                        $('<div class="d-flex align-items-center" style="clear: both;"></div>').append(createHandleIconElement(), header)
                    );
                }
            });
        }
    });
}

/**
 * Add handles to resources for sorting.
 */
function addResourceHandles() {
    $('.sortable-resource>a').each(function () {
        if ($(this).parent().find('.drag-handle').length === 0) {
            $(this).before(createHandleIconElement());
        }
    });
}

// Define the handle icon
const handleIcon = FontAwesome.prefix('solid', 'arrows-up-down-left-right');

// Define the user permissions
const userWeeklyPermissions = $('input[name="userWeeklyPermissions"]').val();

/**
 * Creates a handle icon element to be appended to a section or resource.
 */
function createHandleIconElement() {
    return $('<span class="drag-handle pull-left"><i class="fa-lg ' + handleIcon + '"></i></span>');
}

/**
 * Update positions after sorting.
 */
function updatePositions(context, sortType, movedItemId, moveFrom = null, moveTo = null) {
    const isResourceSort   = sortType === 'resource';
    const isSectionSort    = sortType === 'section';
    const isSubsectionSort = sortType === 'subsection';

    let newPositionsCount    = 0;
    let movedItemNewPosition = null;

    if (isSubsectionSort) {
        context.children('div').not(':first, .alert').each(function (index) {
            let $item       = $(this);
            let newPosition = index + 1;

            $item.attr('data-section-position', newPosition);
            newPositionsCount++;

            if ($item.attr('data-section-id') === movedItemId) {
                movedItemNewPosition = newPosition;
            }
        });
    } else {
        context.children().each(function (index) {
            let $item       = $(this);
            let newPosition = index + 1;

            if (isResourceSort) {
                $item.attr({ 'data-resource-position': newPosition, 'data-section-id': moveTo });
                let idAttribute = isCurriculumSort
                    ? 'data-pagesectionresourceyear-id'
                    : 'data-resource-id';

                newPositionsCount++;

                if ($item.attr(idAttribute) === movedItemId) {
                    movedItemNewPosition = newPosition;
                }
            } else {
                $item.attr('data-section-position', newPosition);
                newPositionsCount++;

                if ($item.attr('data-section-id') === movedItemId) {
                    movedItemNewPosition = newPosition;
                }
            }
        });
    }

    if (moveFrom !== null) {
        if (isResourceSort) {
            moveFrom  = moveFrom.attr('id').replace('section', '');
            moveTo    = moveTo?.attr('id')?.replace('section', '');
        } else if (isSubsectionSort) {
            moveFrom = moveFrom.attr('data-section-id').replace('section', '');
        }
    }

    // If the moved item position has changed, record it
    if (movedItemNewPosition !== null) {
        let changedPositions = { position: movedItemNewPosition };

        // Handle resource sorting
        if (isResourceSort) {
            changedPositions.resourceId = movedItemId;
            changedPositions.moveFrom   = moveFrom;
            changedPositions.moveTo     = moveTo;

            const resourceEndpoint = isCurriculumSort
                ? 'resources/ajax_pages_sections_resources_years_positions'
                : 'weeklyresources/ajax_weekly_resource_positions';

            savePositions(changedPositions, resourceEndpoint);
        } else if (isSubsectionSort || isSectionSort) {
            changedPositions.sectionId = movedItemId;

            if (isSubsectionSort) {
                changedPositions.parentSectionId = moveFrom;
            }

            const commonData = isCurriculumSort
                ? { parentPageId: $('#pageId').val() }
                : { programmeYear: $('#programmeYear').val(), weekNumber: $('#weekNumber').val() };

            Object.assign(changedPositions, commonData);

            const sectionEndpoint = isCurriculumSort
                ? 'resources/ajax_pages_sections_positions'
                : 'weeklyresources/ajax_weekly_section_positions';

            savePositions(changedPositions, sectionEndpoint);
        }
    }

    // Remove or add message based on availability of resources or sections
    if (isResourceSort && newPositionsCount === 0) {
        context.html($('<p class="no-resource-message">No resources available</p>'));
    }
}

/**
 * Send updated position data via AJAX.
 */
function savePositions(data, url) {
    disableDragAndDrop();
    $.ajax({
        url: base_url + url,
        type: 'get',
        dataType: 'json',
        data: { positionData: data },
        success: function () {
            enableDragAndDrop();
        },
        error: function (xhr, status, error) {
            alert('Repositioning failed. AJAX Error: ' + status + ' ' + error);
            location.reload();
        },
    });
}

var fadeTimeout = null;

/**
 * Disable drag and drop functionality for loading.
 */
function disableDragAndDrop() {
    $(initialisedElements.join(', ')).sortable('option', 'disabled', true);
    $('.drag-handle').css('cursor', 'progress');

    if (fadeTimeout !== null) {
        clearTimeout(fadeTimeout);
    }

    fadeTimeout = setTimeout(function () {
        $('.drag-handle').animate({
            opacity: 0.3,
        }, 1000);
    }, 1000);
}

/**
 * Enable drag and drop functionality after loading.
 */
function enableDragAndDrop() {
    $(initialisedElements.join(', ')).sortable('option', 'disabled', false);
    $('.drag-handle').css('opacity', '1').css('cursor', 'move');

    if (fadeTimeout !== null) {
        clearTimeout(fadeTimeout);
        fadeTimeout = null;
    }
}

/**
 *  Format the resource type
 */
function getResourceType(resource) {
    if (resource.type === 'video') {
        return 'Panopto';
    }

    if (resource.type === 'elf') {
        return 'CBL';
    }

    return resource.type
        .replaceAll('-', ' ')
        .replaceAll(/\b\w/g, char => char.toUpperCase());
}

// Disable the section and resource selects on page load
const form = $('.resources-content-form');
form.find('#section_id, #resources_id').prop('disabled', true);

// Event handler for changes in the page select
form.find('select[name="page_id"]').on('change', function () {
    // Refresh resources select
    $('#resources_id')
        .prop('disabled', true)
        .empty()
        .append('<option>Select Resource</option>');

    const pageId = $(this).find('option:selected').val();
    if (pageId !== undefined) {
        getPageSections(pageId);
    }
});

// Event handler for changes in the section select
form.find('select[name="section_id"]').on('change', function () {
    const sectionId = $(this).val();
    if (sectionId !== undefined) {
        getSectionResources(sectionId);
    }
});

/**
 * Get page sections based on the page selected
 * @param string pageId - The ID of the selected page.
 */
function getPageSections(pageId) {
    $.ajax({
        type: 'GET',
        url: base_url + 'weeklyresources/ajax_getSections',
        data: { pageId: pageId },
        dataType: 'json',
        success: function (data) {
            let buildSelect          = '';
            let isAdministrator      = false;
            let canEditSubsectionIds = [];
            let canEditSectionsIds   = [];
            let canEditPageIds       = [];

            // Get IDs of all pages/sections/subsections user has rights to manage
            if (userWeeklyPermissions !== undefined) {
                let parseWeeklyPermissions = JSON.parse(userWeeklyPermissions);

                isAdministrator = parseWeeklyPermissions.isAdministrator;

                canEditSectionsIds = parseWeeklyPermissions.sections
                    .filter(item => item.pages_sections_parent_id === null)
                    .map(item => item.pages_sections_id);

                canEditSubsectionIds = parseWeeklyPermissions.sections
                    .filter(item => item.pages_sections_parent_id !== null)
                    .map(item => ({
                        pages_sections_id: item.pages_sections_id,
                        pages_sections_parent_id: item.pages_sections_parent_id,
                    }));

                canEditPageIds = parseWeeklyPermissions.pages;
            }

            if (data.length > 0) {
                $('#section_id').prop('disabled', false);
                buildSelect += '<option>Select Page Section</option>';
                $.each(data, function (_, section) {
                    // Check if the section is a parent that the user doesn't have rights to, or if the user has rights to add resources to it
                    const isParentSection = canEditSubsectionIds.some(sub => sub.pages_sections_parent_id === section.id);
                    const isDisabledSection = isParentSection ? ' disabled' : '';
                    if (isAdministrator || isParentSection || $.inArray(section.id, canEditSectionsIds) !== -1 || $.inArray(pageId, canEditPageIds) !== -1) {
                        buildSelect += '<option value="' + section.id + '"' + isDisabledSection + '>' + section.name + '</option>';
                    }

                    // Check if the user has permission to add resources to the section and if so, display its subsections, or display only the subsections they have rights to
                    $.each(section.subsections, function (_, subsection) {
                        const canEditSubsection = canEditSubsectionIds.some(sub => sub.pages_sections_id === subsection.id);
                        if (isAdministrator || canEditSubsection || $.inArray(subsection.sections_parent_id, canEditSectionsIds) !== -1 || $.inArray(pageId, canEditPageIds) !== -1) {
                            buildSelect += '<option value="' + subsection.id + '">-- ' + subsection.name + '</option>';
                        }
                    });
                    $('#section_id').empty().prop('disabled', false).append(buildSelect);
                });
            } else {
                $('#section_id, #resources_id').prop('disabled', true);
            }
        },
    });
}

/**
 * Get resources based on the section selected
 * @param string sectionId - The ID of the selected section.
 */
function getSectionResources(sectionId) {
    $.ajax({
        type: 'GET',
        url: base_url + 'weeklyresources/ajax_getSectionResources',
        data: { sectionId: sectionId },
        dataType: 'json',
        success: function (data) {
            let buildSelect = '';
            if (data.length > 0) {
                $('#resources_id').prop('disabled', false);
                buildSelect += '<option>Select Resource</option>';
                $.each(data, function (_, resource) {
                    let resourceType = getResourceType(resource);
                    buildSelect += '<option ' + 'value="' + resource.resources_id + '">' + resource.name + ' (' + resourceType + ')</option>';
                    $('#resources_id').empty().append(buildSelect);
                });
            } else {
                $('#resources_id')
                    .prop('disabled', true)
                    .empty()
                    .append('<option>No resources available</option>');
            }
        },
    });
}

// Move Weekly Resources
const moveWeeklyResourceForm      = $('.move-resources-form');
const weeklyResourcesSubmitButton = moveWeeklyResourceForm.find('button[type="submit"]');
const weeklySectionId             = moveWeeklyResourceForm.find('#weekly_section_id');
const uoaWeekSelect               = moveWeeklyResourceForm.find('#uoa_week');
const programmeYearInput          = moveWeeklyResourceForm.find('input[name="programme_year"]');

// Disable the section select on page load
weeklyResourcesSubmitButton.prop('disabled', true);
weeklySectionId.prop('disabled', true);

// Event handler for changes in the uoaWeek select
uoaWeekSelect.on('change', function () {
    const uoaWeek       = $(this).find('option:selected').val();
    const programmeYear = programmeYearInput.val();
    if (uoaWeek !== '' && programmeYear !== '') {
        getWeeklySectionsByWeek(uoaWeek, programmeYear);
    }
});

/**
 * Get sections based on the week selected for the programme year
 *
 * @param  string uoaWeek
 * @param  string programmeYear
 * @return void
 */
function getWeeklySectionsByWeek(uoaWeek, programmeYear) {
    $.ajax({
        type: 'GET',
        url: base_url + 'weeklyresources/ajax_getWeeklySectionsByWeek',
        data: {
            uoaWeek: uoaWeek,
            programmeYear: programmeYear,
        },
        dataType: 'json',
        success: function (data) {
            const weeklySectionSelect         = $('#weekly_section_id');
            const weeklyResourcesSubmitButton = $('button[type="submit"]');

            let buildSelect = '';
            if (data.length > 0) {
                weeklySectionSelect.prop('disabled', false);
                weeklyResourcesSubmitButton.prop('disabled', false);

                const options = data.map(function (section) {
                    return '<option value="' + section.id + '">' + section.name + '</option>';
                }).join('');

                weeklySectionSelect
                    .empty()
                    .append('<option disabled selected>Select Weekly Section</option>' + options);
            } else {
                weeklySectionSelect
                    .empty()
                    .append('<option>No Weekly Sections in Year ' + programmeYear + ' UoA Week ' + uoaWeek + '</option>')
                    .prop('disabled', true);

                weeklyResourcesSubmitButton.prop('disabled', true);
            }
        },
        error: function (xhr, status, error) {
            alert('Error getting weekly sections. AJAX Error: ' + status + ' ' + error);
        },
    });
}
